var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"disabled":_vm.disabled,"rules":_vm.ruleList,"outlined":"","type":"number"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=_vm._n($$v)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }